import { api } from './api';
import { FAVORITES_CHANGED } from './events';

/**
 * SSOT für „Favoriten-Toggle gegen den Server + Event-Broadcast" (Roadmap 3a
 * Phase 3). `PUT`/`DELETE /api/assets/:id/favorite` je nach aktuellem Stand, bei
 * Erfolg `FAVORITES_CHANGED` dispatchen (damit ALLE gemounteten Stern-Instanzen
 * derselben id syncen). Gibt den neuen Stand zurück; **wirft** bei API-Fehler —
 * der Caller behandelt (useFavoriteToggle: optimistic-revert + Toast; F-Handler
 * ohne optimistic: nur Toast).
 *
 * Genutzt von `useFavoriteToggle` (Stern-Buttons + Overlay-F) und dem
 * Library-Grid-`F`-Handler (dynamische hovered-id, kein per-id-Hook möglich).
 */
export async function toggleAssetFavorite(
  assetId: string,
  currentFavorited: boolean,
): Promise<boolean> {
  const next = !currentFavorited;
  await api(`/api/assets/${assetId}/favorite`, { method: next ? 'PUT' : 'DELETE' });
  window.dispatchEvent(new CustomEvent(FAVORITES_CHANGED, { detail: { assetId, favorited: next } }));
  return next;
}
